import datingIcon from '../assets/images/dating-app-logo.png';

const Logo = () => {
  return <img src={datingIcon} alt='Dating app logo' className='logo' />;
};
export default Logo;
